import imagesReducer from "./reducer"
import imagesSaga from "./sagas"

const saga = {
  reducers: imagesReducer,
  sagas: imagesSaga
}

export default saga